import { IScoreCard } from "../../models/input/sellOutApi/IScoreCard";
import { ISellOut } from "../../models/input/sellOutApi/ISellOut";
import { ISellOutDelete } from "../../models/input/sellOutApi/ISellOutDelete";
import { ISellOutEmail } from "../../models/input/sellOutApi/ISellOutEmail";
import { ISellOutFile } from "../../models/input/sellOutApi/ISellOutFile";
import { ISellOutJson } from "../../models/input/sellOutApi/ISellOutJson";
import { ISellOutUpdateActive } from "../../models/input/sellOutApi/ISellOutUpdateActive";
import * as ApiWithToken from "../callApiWithToken";

const apiUrlAgenda = process.env.REACT_APP_AGENDAS_API;
const apiUrlProducts = process.env.REACT_APP_PCB_PRODUCTS_API

const SellOutService = {
  sellOutFile: async function (form: ISellOutFile) {
    return ApiWithToken.postApi(`${apiUrlAgenda}Sale/CreateSellOutFile`, form);
  },

  sellOutLocal: async function (json: ISellOutJson[], SellOutFileIDIn: number) {
    return ApiWithToken.postApi(
      `${apiUrlAgenda}Sale/CreateSellOutLocal?SellOutFileIDIn=${SellOutFileIDIn}`,
      json
    );
  },

  sellOut: async function (form: ISellOut) {
    return ApiWithToken.postApi(`${apiUrlAgenda}Sale/CreateSellOut`, form);
  },

  sellOutNotification: async function (
    UserID: number,
    TemplateID: number,
    LanguageID: number,
    FileName: string,
    ErrorFileName: string
  ) {
    return ApiWithToken.getApi(
      `${apiUrlAgenda}Sale/SendCreatedSellOutNotification?UserID=${UserID}&TemplateID=${TemplateID}&LanguageID=${LanguageID}&FileName=${FileName}&ErrorFileName=${ErrorFileName}`
    );
  },

  sendEmailSellOut: async function (form: ISellOutEmail) {
    return ApiWithToken.postApi(`${apiUrlAgenda}Sale/SendEmail`, form);
  },

  getMissingProduct: async function (UserId: number, SellOutId: number) {
    return ApiWithToken.getApi(`${apiUrlAgenda}Sale/GetMissingProduct?UserID=${UserId}&SellOutId=${SellOutId}`);
  },

  pcbProducts: async function (sku: string[]) {
    return ApiWithToken.postApi(`${apiUrlProducts}PcbProducts`, sku);
  },

  getSellOutFileList: async function () {
    return ApiWithToken.getApi(`${apiUrlAgenda}Sale/GetSellOutFileList`);
  },

  deleteSellOut: async function (form: ISellOutDelete) {
    return ApiWithToken.putApi(`${apiUrlAgenda}Sale/DeleteSellOut`, form);
  },

  getSellOutFilesDeleted: async function () {
    return ApiWithToken.getApi(`${apiUrlAgenda}Sale/GetSellOutFilesDeleted`);
  },

  UpdateSellOutActivate: async function (form: ISellOutUpdateActive) {
    return ApiWithToken.putApi(`${apiUrlAgenda}Sale/UpdateSellOutActivate`, form);
  },

  deleteSellOutEmpty: async function (form: ISellOutDelete) {
    return ApiWithToken.putApi(`${apiUrlAgenda}Sale/DeleteSellOutEmpty`, form);
  },

  getScoreCard: async function (form: IScoreCard) {
    return ApiWithToken.getApi(`${apiUrlAgenda}Sale/GetScoreCard?StartDate=${form.StartDate}&FirstSunday=${form.FirstSunday}&SecondSunday=${form.SecondSunday}&ThirdSunday=${form.ThirdSunday}&FourthSunday=${form.FourthSunday}&FifthSunday=${form.FifthSunday}&UserID=0`);
  },
};

export default SellOutService;
